import styled from 'styled-components';
import {PublicProfilesProps} from "@betrue/ui";
import {Profile, StyledBaseProps} from "@betrue/shared/interfaces";
import {Grid, Typography} from "@mui/material";
import {PublicProfileCardView} from "./pulic-profile-card.view";

interface PublicProfilesViewProps extends PublicProfilesProps, StyledBaseProps {
  profiles: Profile[]
}

export const PublicProfilesView = styled((props: PublicProfilesViewProps) => (
  <div className={props.className}>
    {props.profiles.length ?
      <Grid container direction={'row'} spacing={2} alignItems={'center'} alignContent={'center'}>
        {props.profiles.map((profile) => (
          <Grid key={profile.id} item sm={4} xs={12} lg={3}>
            <PublicProfileCardView profile={profile} person={profile.person}/>
          </Grid>))}
      </Grid>
      : <Grid container direction={'column'} spacing={2} alignItems={'center'} className={'bt-no-profiles'}>
        <Grid item><Typography
          variant={'h4'}>{props.noProfilesLabel ? props.noProfilesLabel : 'ya personne !'} 🙄</Typography>
        </Grid>
      </Grid>}
  </div>
))`
  & .bt-no-profiles {
    color: ${props => props.theme.colors.text};
  }

`
